/**
 * P07 B6 bổ sung (anh Tiến 06/10/2026: "tất cả các thông tin đều song ngữ"): bảng thuật ngữ dịch sẵn
 * cho bản báo giá tiếng Anh / tiếng Trung khi dòng chưa có tên dịch.
 * - Tên hàng: dịch theo cụm từ ngành (thép, ống, phụ kiện, PCCC, dịch vụ); mã, quy cách, hãng (D10, (HP), Gr40) giữ nguyên.
 *   Còn chữ tiếng Việt chưa dịch được thì coi như thiếu tên (in tên Việt, vẫn cảnh báo) để không in nửa Việt nửa Trung.
 * - ĐVT và điều khoản mặc định của báo giá.
 * Tên dịch gõ tay / tên dịch của mã luôn ưu tiên hơn bảng này.
 */
export type TranslationLang = 'en' | 'zh';

// [tiếng Việt, English, 中文]. Cụm dài khớp trước cụm ngắn.
const NAME_TERMS: [string, string, string][] = [
  // Thép
  ['thép gân', 'Rebar', '螺纹钢'],
  ['thép thanh vằn', 'Rebar', '螺纹钢'],
  ['sắt gân', 'Rebar', '螺纹钢'],
  ['thép tròn trơn', 'Plain round bar', '圆钢'],
  ['thép tròn đặc', 'Round bar', '圆钢'],
  ['thép cuộn', 'Wire rod', '盘圆'],
  ['thép hộp mạ kẽm', 'Galvanized hollow section', '镀锌方管'],
  ['thép hộp vuông', 'Square hollow section', '方管'],
  ['thép hộp chữ nhật', 'Rectangular hollow section', '矩形管'],
  ['thép hộp đen', 'Black hollow section', '黑方管'],
  ['thép hộp', 'Hollow section', '方管'],
  ['thép tấm', 'Steel plate', '钢板'],
  ['tôn mạ kẽm', 'Galvanized steel sheet', '镀锌板'],
  ['tôn', 'Steel sheet', '钢板'],
  ['thép hình chữ i', 'I-beam', '工字钢'],
  ['thép hình i', 'I-beam', '工字钢'],
  ['thép chữ i', 'I-beam', '工字钢'],
  ['thép hình chữ h', 'H-beam', 'H型钢'],
  ['thép hình h', 'H-beam', 'H型钢'],
  ['thép chữ h', 'H-beam', 'H型钢'],
  ['thép hình chữ u', 'U-channel', '槽钢'],
  ['thép hình u', 'U-channel', '槽钢'],
  ['thép chữ u', 'U-channel', '槽钢'],
  ['thép hình chữ c', 'C-channel', 'C型钢'],
  ['thép hình c', 'C-channel', 'C型钢'],
  ['thép chữ c', 'C-channel', 'C型钢'],
  ['xà gồ', 'Purlin', '檩条'],
  ['thép góc', 'Angle bar', '角钢'],
  ['thép hình v', 'Angle bar', '角钢'],
  ['thép chữ v', 'Angle bar', '角钢'],
  ['thép v', 'Angle bar', '角钢'],
  ['lưới thép', 'Steel mesh', '钢丝网'],
  ['dây thép buộc', 'Binding wire', '扎丝'],
  ['kẽm buộc', 'Binding wire', '扎丝'],
  ['tấm inox', 'Stainless steel sheet', '不锈钢板'],
  ['inox', 'Stainless steel', '不锈钢'],
  ['thép', 'Steel', '钢'],
  // Ống
  ['ống thép mạ kẽm', 'Galvanized steel pipe', '镀锌钢管'],
  ['ống thép đen', 'Black steel pipe', '黑钢管'],
  ['ống thép hàn', 'Welded steel pipe', '焊接钢管'],
  ['ống thép đúc', 'Seamless steel pipe', '无缝钢管'],
  ['ống thép', 'Steel pipe', '钢管'],
  ['ống inox', 'Stainless steel pipe', '不锈钢管'],
  ['ống nhựa pvc', 'PVC pipe', 'PVC管'],
  ['ống nhựa hdpe', 'HDPE pipe', 'HDPE管'],
  ['ống nhựa ppr', 'PPR pipe', 'PPR管'],
  ['ống pvc', 'PVC pipe', 'PVC管'],
  ['ống hdpe', 'HDPE pipe', 'HDPE管'],
  ['ống ppr', 'PPR pipe', 'PPR管'],
  ['ống nhựa', 'Plastic pipe', '塑料管'],
  ['ống mềm', 'Flexible hose', '软管'],
  ['ống', 'Pipe', '管'],
  // Phụ kiện ống
  ['co hàn', 'Welded elbow', '焊接弯头'],
  ['co ren', 'Threaded elbow', '螺纹弯头'],
  ['cút hàn', 'Welded elbow', '焊接弯头'],
  ['cút', 'Elbow', '弯头'],
  ['co', 'Elbow', '弯头'],
  ['tê hàn', 'Welded tee', '焊接三通'],
  ['tê ren', 'Threaded tee', '螺纹三通'],
  ['tê', 'Tee', '三通'],
  ['bầu giảm', 'Reducer', '异径管'],
  ['côn thu', 'Reducer', '异径管'],
  ['mặt bích', 'Flange', '法兰'],
  ['măng sông', 'Coupling', '管箍'],
  ['măng xông', 'Coupling', '管箍'],
  ['rắc co', 'Union', '活接'],
  ['nắp bịt', 'Cap', '管帽'],
  ['bịt đầu', 'Cap', '管帽'],
  ['kép', 'Nipple', '对丝'],
  ['khớp nối mềm', 'Flexible coupling', '软接头'],
  ['khớp nối', 'Coupling', '接头'],
  ['khớp nối nhanh', 'Grooved coupling', '沟槽卡箍'],
  // Van
  ['van bướm', 'Butterfly valve', '蝶阀'],
  ['van cổng', 'Gate valve', '闸阀'],
  ['van bi', 'Ball valve', '球阀'],
  ['van một chiều', 'Check valve', '止回阀'],
  ['van 1 chiều', 'Check valve', '止回阀'],
  ['van giảm áp', 'Pressure reducing valve', '减压阀'],
  ['van an toàn', 'Safety valve', '安全阀'],
  ['van báo động', 'Alarm valve', '报警阀'],
  ['van xả khí', 'Air release valve', '排气阀'],
  ['van góc', 'Angle valve', '角阀'],
  ['van', 'Valve', '阀门'],
  // PCCC
  ['đầu phun sprinkler', 'Sprinkler head', '喷头'],
  ['đầu phun', 'Sprinkler head', '喷头'],
  ['bình chữa cháy', 'Fire extinguisher', '灭火器'],
  ['tủ chữa cháy', 'Fire hose cabinet', '消防箱'],
  ['tủ pccc', 'Fire hose cabinet', '消防箱'],
  ['cuộn vòi chữa cháy', 'Fire hose reel', '消防卷盘'],
  ['vòi chữa cháy', 'Fire hose', '消防水带'],
  ['lăng phun', 'Fire nozzle', '水枪'],
  ['trụ chữa cháy', 'Fire hydrant', '消火栓'],
  ['họng chữa cháy', 'Fire hydrant valve', '消火栓'],
  ['công tắc dòng chảy', 'Flow switch', '水流指示器'],
  ['đồng hồ áp lực', 'Pressure gauge', '压力表'],
  ['đồng hồ áp suất', 'Pressure gauge', '压力表'],
  ['bơm chữa cháy', 'Fire pump', '消防泵'],
  ['máy bơm', 'Pump', '水泵'],
  ['chuông báo cháy', 'Fire alarm bell', '火警警铃'],
  ['đầu báo khói', 'Smoke detector', '烟感探测器'],
  ['đầu báo nhiệt', 'Heat detector', '温感探测器'],
  ['tủ trung tâm báo cháy', 'Fire alarm control panel', '火灾报警控制器'],
  ['đèn exit', 'Exit sign', '安全出口指示灯'],
  ['đèn sự cố', 'Emergency light', '应急灯'],
  // Vật tư, điện nước
  ['bu lông', 'Bolt', '螺栓'],
  ['đai ốc', 'Nut', '螺母'],
  ['ê cu', 'Nut', '螺母'],
  ['long đền', 'Washer', '垫圈'],
  ['ty ren', 'Threaded rod', '丝杆'],
  ['kẹp treo', 'Pipe hanger', '吊卡'],
  ['quang treo', 'Pipe hanger', '吊卡'],
  ['cùm treo', 'Pipe clamp', '管卡'],
  ['gioăng', 'Gasket', '垫片'],
  ['que hàn', 'Welding rod', '焊条'],
  ['dây điện', 'Electric wire', '电线'],
  ['cáp điện', 'Power cable', '电缆'],
  ['sơn chống rỉ', 'Anti-rust paint', '防锈漆'],
  ['sơn', 'Paint', '油漆'],
  // Dịch vụ
  ['phí vận chuyển', 'Transportation', '运费'],
  ['vận chuyển', 'Transportation', '运费'],
  ['cẩu hàng', 'Crane service', '吊装费'],
  ['gia công', 'Fabrication', '加工'],
  ['lắp đặt', 'Installation', '安装'],
  ['cắt', 'Cutting', '切割'],
  // Bề mặt, đặc tính
  ['mạ kẽm nhúng nóng', 'Hot-dip galvanized', '热镀锌'],
  ['mạ kẽm', 'Galvanized', '镀锌'],
  ['nhúng nóng', 'Hot-dip', '热浸'],
  ['đen', 'Black', '黑'],
  ['hàn', 'Welded', '焊接'],
  ['ren', 'Threaded', '螺纹'],
  ['dày', 'Thickness', '厚'],
  ['dài', 'Length', '长'],
  ['loại', 'Type', '型'],
];

// ĐVT: khóa viết thường
const UNIT_TERMS: Record<string, [string, string]> = {
  kg: ['kg', '公斤'],
  tấn: ['ton', '吨'],
  cây: ['pcs', '根'],
  thanh: ['bar', '根'],
  ống: ['pcs', '根'],
  m: ['m', '米'],
  mét: ['m', '米'],
  md: ['m', '米'],
  m2: ['m²', '平方米'],
  'm²': ['m²', '平方米'],
  m3: ['m³', '立方米'],
  'm³': ['m³', '立方米'],
  cái: ['pc', '个'],
  chiếc: ['pc', '个'],
  con: ['pc', '个'],
  quả: ['pc', '个'],
  bộ: ['set', '套'],
  tấm: ['sheet', '张'],
  cuộn: ['roll', '卷'],
  hộp: ['box', '盒'],
  thùng: ['carton', '箱'],
  bao: ['bag', '袋'],
  bình: ['unit', '具'],
  lít: ['liter', '升'],
  chuyến: ['trip', '趟'],
  gói: ['lot', '项'],
  lô: ['lot', '批'],
  kiện: ['package', '件'],
  ca: ['shift', '台班'],
  km: ['km', '公里'],
  lần: ['time', '次'],
  đôi: ['pair', '双'],
  cặp: ['pair', '对'],
  công: ['man-day', '工日'],
  giờ: ['hour', '小时'],
  ngày: ['day', '天'],
  tháng: ['month', '月'],
};

// Điều khoản mặc định của báo giá mới (GET /quotes/defaults) dịch sẵn; nội dung gõ khác in nguyên văn.
const TERM_SENTENCES: [string, string, string][] = [
  [
    'Giao hàng tại kho bên mua trong nội thành; chi phí bốc xếp xuống hàng do bên mua chịu.',
    "Delivery to the buyer's warehouse within the city; unloading costs are borne by the buyer.",
    '市区内送货至买方仓库；卸货费用由买方承担。',
  ],
  ['03 – 05 ngày làm việc kể từ khi nhận đơn đặt hàng.', '03 – 05 working days from receipt of the purchase order.', '收到订单后03 – 05个工作日。'],
  ['Thanh toán 100% bằng chuyển khoản trước khi giao hàng.', '100% payment by bank transfer before delivery.', '交货前以银行转账方式支付100%货款。'],
];

const norm = (s: string) => s.normalize('NFC').toLowerCase().replace(/\s+/g, ' ').trim();
const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const TERM_MAP = new Map(NAME_TERMS.map(([vi, en, zh]) => [norm(vi), { en, zh }]));
const TERM_RE = new RegExp(
  `(?<![\\p{L}\\p{N}])(${[...TERM_MAP.keys()].sort((a, b) => b.length - a.length).map((k) => escape(k).replace(/ /g, '\\s+')).join('|')})(?![\\p{L}\\p{N}])`,
  'giu',
);
// Chữ Latin có dấu (tiếng Việt) còn sót sau khi dịch = chưa dịch hết
const VI_LEFT = /[À-ɏḀ-ỿ]/;
const CJK = '\\u3400-\\u9FFF\\uF900-\\uFAFF';

/** Dịch tên hàng theo bảng thuật ngữ; null khi không dịch được trọn (còn chữ Việt) hoặc không có cụm nào khớp. */
export function autoTranslateName(name: string | null | undefined, lang: TranslationLang): string | null {
  const src = name?.normalize('NFC').trim();
  if (!src) return null;
  let hit = false;
  let out = src.replace(TERM_RE, (m) => {
    const t = TERM_MAP.get(norm(m));
    if (!t) return m;
    hit = true;
    return t[lang];
  });
  if (!hit || VI_LEFT.test(out)) return null;
  out = out.replace(/\s+/g, ' ').trim();
  // Tiếng Trung: bỏ khoảng trắng giữa 2 chữ Hán ("镀锌 钢管" → "镀锌钢管")
  if (lang === 'zh') out = out.replace(new RegExp(`([${CJK}])\\s+(?=[${CJK}])`, 'gu'), '$1');
  return out;
}

/** ĐVT dịch sẵn; ĐVT lạ trả null (in nguyên văn). */
export function translateUnit(unit: string | null | undefined, lang: TranslationLang): string | null {
  if (!unit) return null;
  const t = UNIT_TERMS[norm(unit)];
  return t ? t[lang === 'en' ? 0 : 1] : null;
}

const SENTENCE_MAP = new Map(TERM_SENTENCES.map(([vi, en, zh]) => [norm(vi), { en, zh }]));

/** Điều khoản mặc định dịch sẵn; nội dung gõ khác trả null. */
export function translateTermText(text: string | null | undefined, lang: TranslationLang): string | null {
  if (!text) return null;
  return SENTENCE_MAP.get(norm(text))?.[lang] ?? null;
}
